import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const Container = styled.section`
  overflow-y: ${(props) => !props.disableScroll && 'scroll'};
  height: ${(props) => !props.disableScroll && '100%'};
  padding-bottom: ${(props) => (props.instructions ? '220px' : '100px')};
`;

export const ContentWrapper = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 19px 13px;
`;

export const MacroHeading = styled.h3`
  margin: 0px;
  padding: 0px;
  color: ${colors.purple1};
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

export const ActionButtons = styled.div`
  align-items: flex-start;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0px 10px;
`;

ActionButtons.displayName = 'ActionButtons';

export const VersionToggleLink = styled.p`
  text-decoration: underline;
  font-weight: 700;
  color: black;
  cursor: pointer;
`;

export const LoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const HeadingSection = styled.section`
  padding: 16px 16px 0px;
`;

export const BlockingAlert = styled.p`
  display: inline-block;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  color: ${colors.black4};
  padding: 0px 10px 0px 10px;
  margin: 0px;

  @media screen and (max-width: 1350px) {
    font-size: 10px;
  }
`;
